import React from "react";
import { withRouter } from "react-router-dom";
import Header from "./common/Header.js";
import Footer from "./common/Footer.js";
import api from "./api/Api.js";
import { WEB_ROOT } from "./config/ApiConfig.js";
import Copy from "./images/Copy.svg";

class Partner extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      errors: {},
      id: "",
      inviteCode: "",
      firstName: "",
      lastName: "",
      email: "",
      isSubmitting: false,
      showConfirmation: false,
      showCopied: false,
      inviteCodeInvalid: false,
    };

    // Re-routing to newer marketing webpage.
    window.location.href = "https://www.getduos.com";
  }

  handleChange = (event) => {
    const { name, value } = event.target;
    this.setState({ [name]: value });
  };

  errorHandler = (e) => {
    return this.state.errors[e] ? { borderColor: "red", filter: "drop-shadow(0px 0px 3px red)" } : {};
  };

  sectionInvite = () => {
    return (
      <div className="section wide img light gray apply">
        <div className="memberpod invite" style={{ backgroundColor: "#FFFFFF", paddingBottom: "30px" }}>
          <div>
            <h2 className="heading-5 lightbg leftheading sub">Invite Code</h2>
            <p className="caption" style={{ marginBottom: "0px" }}>
              We use this to associate members you refer with your organization.
            </p>
            <div className="formfield half">
              <input
                value={this.state.inviteCode}
                onChange={this.handleChange}
                type="text"
                className="text-field memberinput w-input"
                style={Object.assign({ minWidth: "300px", width: "50%" }, this.errorHandler("inviteCode"))}
                maxLength="256"
                name="inviteCode"
                placeholder=""
                id="inviteCode"
                required="required"
              />
            </div>
            <label id="contact-email" className="caption invite">
              Can’t find your invite code? Give us a call 855-212-9242.
            </label>
          </div>
        </div>
      </div>
    );
  };

  sectionCareManagerContact = () => {
    return (
      <div className="section wide img light gray apply">
        <div className="memberpod">
          <h2 className="heading-5 lightbg leftheading" style={{ marginBottom: "5px" }}>
            Contact Information
          </h2>
          <p className="caption" style={{ marginBottom: "0px" }}>
            Your information will be associated with the member referral.
          </p>
          <div className="w-container">
            <div className="contact-form-grid-2">
              <div className="collapseMobile">
                <label htmlFor="firstName" className="field-label left">
                  First&nbsp;Name
                </label>
                <input
                  value={this.state.firstName}
                  onChange={this.handleChange}
                  type="text"
                  className="text-field memberinput w-input"
                  style={this.errorHandler("firstName")}
                  maxLength="256"
                  name="firstName"
                  placeholder=""
                  id="firstName"
                  required="required"
                />
              </div>
              <div className="collapseMobile">
                <label htmlFor="lastName" className="field-label">
                  Last&nbsp;Name
                </label>
                <input
                  value={this.state.lastName}
                  onChange={this.handleChange}
                  type="text"
                  className="text-field memberinput w-input"
                  style={this.errorHandler("lastName")}
                  maxLength="256"
                  name="lastName"
                  placeholder=""
                  id="lastName"
                  required="required"
                />
              </div>
            </div>
            <div>
              <div>
                <label htmlFor="email" className="field-label">
                  Email
                </label>
                <input
                  value={this.state.email}
                  onChange={this.handleChange}
                  type="email"
                  className="text-field memberinput w-input"
                  style={Object.assign({ width: "100%", maxWidth: "500px" }, this.errorHandler("email"))}
                  maxLength="256"
                  name="email"
                  placeholder=""
                  id="email"
                  required="required"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  shorten = (link) => {
    return link.substring(0, 40) + "...";
  };

  copy = () => {
    navigator.clipboard.writeText(WEB_ROOT + "/refer/" + this.state.id);
    this.setState({ showCopied: true });
    setTimeout(() => {
      this.setState({ showCopied: false });
    }, 1500);
  };

  sectionConfirmation = () => {
    return (
      <div id="about" className="section wide img light confirmation">
        <div className="wrap confirmation">
          <h2 className="heading-4 confirm" style={{ marginBottom: "20px" }}>
            Thanks {this.state.firstName}!<br />
            Account Created!
          </h2>
          <div className="confirmationcontainer w-container" style={{ marginBottom: "0px" }}>
            <h2 style={{ width: "85%", marginBottom: "20px" }} className="paragraph-2 confirmation">
              Use your personalized link below to refer future members. Your unique url has been sent to your email.
              <br />
            </h2>
            <h2
              style={{
                width: "auto",
                backgroundColor: "#612585",
                borderRadius: "17px",
                paddingLeft: "30px",
                paddingRight: "30px",
                paddingTop: "10px",
                paddingBottom: "10px",
              }}
              className="paragraph-2 confirmation"
            >
              <a href={"/refer/" + this.state.id} style={{ color: "white", textDecoration: "none" }}>
                {this.shorten("member.getduos.com/refer/" + this.state.id)}
              </a>
              <div style={{ display: "inline-block", position: "relative" }}>
                <img alt="Copy Link" src={Copy} className="copyIcon" onClick={this.copy} />
                <div className={this.state.showCopied ? "blackTooltipHidden blackTooltip" : "blackTooltipHidden"}>
                  Link Copied
                </div>
              </div>
            </h2>
          </div>
          <p style={{ color: "white", marginBottom: "30px" }}>Save it to your bookmarks</p>
          <a href={"/refer/" + this.state.id} className="button-hero sub w-button">
            Refer New Member
          </a>
        </div>
      </div>
    );
  };

  doSubmit = (event) => {
    event.preventDefault();
    this.setState({ isSubmitting: true }, () => {
      api
        .caremanagerSignup(
          this.state.firstName.trim(),
          this.state.lastName.trim(),
          this.state.email.trim(),
          this.state.inviteCode.trim()
        )
        .then((response) => {
          if (response.status === 200 || response.status === 201) {
            this.setState({ isSubmitting: false, showConfirmation: true, id: response.body.userId });
          } else if (response.status === 400) {
            this.setState({ isSubmitting: false });
            if (response.body.message) {
              this.setState({ errorMessage: true });
            }
            var errList = {};
            for (var ii = 0; ii < response.body.length; ii++) {
              if (response.body[ii].field === "inviteCode") {
                this.setState({ inviteCodeInvalid: true });
              }
              errList[response.body[ii].field] = response.body[ii]?.message || true;
            }
            if (errList) this.setState({ errors: errList });
          } else {
            this.setState({ isSubmitting: false, errorMessage: true });
          }
        });
    });
  };

  render() {
    if (this.state.showConfirmation) {
      return (
        <div className="App confirmationBG" style={{ minHeight: "100vh" }}>
          <Header />
          {this.sectionConfirmation()}
          <Footer confirmation={true} />
        </div>
      );
    } else {
      return (
        <div className="App" style={{ backgroundColor: "#f3f3f3" }}>
          <Header />
          <div>
            <div className="section center small apply" style={{ height: "112px" }}>
              <div>
                <h1 className="paragraph purple apply" style={{ margin: "0" }}>
                  Create Your DUOS Referral Account
                </h1>
              </div>
            </div>
          </div>
          <form onSubmit={this.doSubmit}>
            {this.sectionCareManagerContact()}
            {this.sectionInvite()}
            <div className="memberpod privacy">
              <div className="w-container">
                <div style={{ marginBottom: "35px" }}>
                  <button
                    type="submit"
                    className="button-hero sub purple w-button"
                    style={{ width: "100%" }}
                    disabled={this.state.isSubmitting}
                  >
                    <span style={{ display: this.state.isSubmitting ? "none" : "block" }}>Continue</span>
                    <svg
                      style={{ display: this.state.isSubmitting ? "block" : "none" }}
                      className="spinner"
                      version="1.1"
                      id="L9"
                      x="0px"
                      y="0px"
                      viewBox="0 0 100 100"
                      enableBackground="new 0 0 0 0"
                    >
                      <path
                        fill="#fff"
                        d="M73,50c0-12.7-10.3-23-23-23S27,37.3,27,50 M30.9,50c0-10.5,8.5-19.1,19.1-19.1S69.1,39.5,69.1,50"
                      >
                        <animateTransform
                          attributeName="transform"
                          attributeType="XML"
                          type="rotate"
                          dur="1s"
                          from="0 50 50"
                          to="360 50 50"
                          repeatCount="indefinite"
                        />
                      </path>
                    </svg>
                  </button>
                  <p
                    style={{
                      display:
                        JSON.stringify(this.state.errors) !== "{}" && !this.state.errors?.inviteCode ? "block" : "none",
                      textAlign: "center",
                      color: "red",
                      fontWeight: "700",
                      marginTop: "10px",
                    }}
                  >
                    *Invalid values found in highlighted fields above, please fix and try again.
                  </p>
                  <p
                    style={{
                      display: this.state.errorMessage ? "block" : "none",
                      textAlign: "center",
                      color: "red",
                      fontWeight: "700",
                      marginTop: "10px",
                    }}
                  >
                    We are experiencing system issues at the moment, please try again later or give us a call. We
                    apologize for the inconvenience.
                  </p>
                  <p
                    style={{
                      display: this.state.errors?.inviteCode ? "block" : "none",
                      textAlign: "center",
                      color: "red",
                      fontWeight: "700",
                      marginTop: "10px",
                    }}
                  >
                    Invite code is no longer valid.
                  </p>
                </div>
                <div style={{ textAlign: "center" }}>
                  <p className="phoneBottomText">Call anytime to apply by phone</p>
                  <p>
                    <a href="tel:8552129242" className="telBottom">
                      855 212 9242
                    </a>
                  </p>
                </div>
              </div>
            </div>
          </form>
          <Footer />
        </div>
      );
    }
  }
}

export default withRouter(Partner);
